// Config used by the web clients

// Set and import config data first
import Config from './web/config';

// Import third party JS/CSS
import './web/importLibs';

// Import other one-time config items
import './yupAddPhone';
import './yupAddMomentDate';

export default Config;
